export function useAvailability(
  availability: MaybeRefOrGetter<string>,
  reAvailabilityDate?: MaybeRefOrGetter<string | undefined>,
) {
  const { t } = useI18n()
  const { $moment } = useNuxtApp()

  const isReAvailabilityDateInTheFuture = computed(() => {
    const date = toValue(reAvailabilityDate)
    return !!date && $moment(new Date()).diff(date) < 0
  })

  const mappedAvailabilityStatus = computed(() => {
    const status = toValue(availability)
    if (isReAvailabilityDateInTheFuture.value) {
      switch (status) {
        case 'SHORT_TERM_NOT_AVAILABLE':
        case 'MEDIUM_TERM_NOT_AVAILABLE':
        case 'LONG_TERM_NOT_AVAILABLE':
          return 'available_earliest_from'
        case 'NOT_AVAILABLE':
          return 'not_available_until'
        default:
          return 'probably_available'
      }
    }

    switch (status) {
      case 'SHORT_TERM_NOT_AVAILABLE':
        return 'short_term_not_available'
      case 'MEDIUM_TERM_NOT_AVAILABLE':
        return 'medium_term_not_available'
      case 'LONG_TERM_NOT_AVAILABLE':
        return 'long_term_not_available'
      case 'NOT_AVAILABLE':
        return 'not_available'
      default:
        return 'probably_available'
    }
  })

  const availabilityMessage = computed(() => {
    const date = toValue(reAvailabilityDate)
    const statusText = t(`product.availability.${mappedAvailabilityStatus.value}`)

    if (date
      && mappedAvailabilityStatus.value !== 'probably_available'
      && isReAvailabilityDateInTheFuture.value) {
      return `${statusText}: ${$moment(date).format(t('date.format'))}`
    }

    return statusText
  })

  const availabilityColor = computed(() => {
    switch (toValue(availability)) {
      case 'SHORT_TERM_NOT_AVAILABLE':
      case 'MEDIUM_TERM_NOT_AVAILABLE':
      case 'LONG_TERM_NOT_AVAILABLE':
        return 'text-heiland-orange text-vm-yellow'
      case 'NOT_AVAILABLE':
        return 'text-primary text-vm-red-900'
      default:
        return 'text-heiland-green'
    }
  })

  return {
    availabilityMessage,
    availabilityColor,
    mappedAvailabilityStatus,
    isReAvailabilityDateInTheFuture,
  }
}
